<template>
    <div class="customer-address-book-component">
        <mobile-go-back-button></mobile-go-back-button>
        <h2 class="mb-10">{{ trans.get('customer.address-book') }}</h2>
        <div class="address flex flex-col">
            <div class="flex items-center mb-8" v-show="hasAddress && ! editing">
                <span class="font-bold">{{ trans.get('customer.shipping-address') }}</span>
                <span class="material-icons mr-4 ml-auto cursor-pointer" @click="editing = true">edit</span>
                <span class="material-icons mr-3 cursor-pointer" @click="deleteAddress">delete</span>
            </div>

            <div v-if="hasAddress && ! editing">
                <p class="mb-1">{{ addressData.address }} {{ addressData.extra_info }}</p>
                <p>{{ addressData.postal_code }} {{ addressData.city }}</p>
            </div>

            <form v-if="! hasAddress || editing" @submit.prevent="handleSubmit">
                <floating-input
                    class="mb-5"
                    name="name"
                    :placeholder="trans.get('customer.name')"
                    type="text"
                    :initial-value="addressData.name"
                    @input="addressData.name = $event"
                ></floating-input>
                <floating-input
                    class="mb-5"
                    name="surname"
                    :placeholder="trans.get('customer.surname')"
                    type="text"
                    :initial-value="addressData.surname"
                    @input="addressData.surname = $event"
                ></floating-input>
                <floating-input
                    class="mb-5"
                    name="address"
                    :placeholder="trans.get('customer.address')"
                    type="text"
                    :initial-value="addressData.address"
                    @input="addressData.address = $event"
                ></floating-input>
                <floating-input
                    class="mb-5"
                    name="extra_info"
                    :placeholder="trans.get('customer.extra-info')"
                    type="text"
                    :initial-value="addressData.extra_info"
                    @input="addressData.extra_info = $event"
                ></floating-input>
                <floating-input
                    class="mb-5"
                    name="city"
                    :placeholder="trans.get('customer.city')"
                    type="text"
                    :initial-value="addressData.city"
                    @input="addressData.city = $event"
                ></floating-input>
                <floating-input
                    class="mb-5"
                    name="postal_code"
                    :placeholder="trans.get('customer.postal-code')"
                    type="text"
                    :initial-value="addressData.postal_code"
                    @input="addressData.postal_code = $event"
                ></floating-input>
                <v-select
                    class="mb-5"
                    name="country"
                    :options="regions.map((r) => r.name)"
                    :placeholder="trans.get('customer.country')"
                    :value="addressData.country"
                    @input="addressData.country = $event"
                >
                </v-select>
                <floating-input
                    class="mb-10"
                    name="observations"
                    :placeholder="trans.get('customer.observations')"
                    type="text"
                    :initial-value="addressData.observations"
                    @input="addressData.observations = $event"
                ></floating-input>
                <button class="btn btn-primary has-spinner block mx-auto lg:mx-0">
                    <span v-show="! loading">{{ trans.get('customer.save-address') }}</span>
                    <span v-show="loading" class="spinner"></span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import MobileGoBackButton from './MobileGoBackButton';
import {
    RETREIVE_REGIONS,
    GET_REGIONS,
} from "../../store/wizard/types";
import { mapActions, mapGetters } from 'vuex';

const addressData = {
    name: '',
    surname: '',
    address: '',
    extra_info: '',
    postal_code: '',
    city: '',
    country: '',
    observations: ''
};

export default {
    components: {
        MobileGoBackButton,
    },

    data() {
        return {
            editing: false,
            loading: false,
            addressData: { ...this.$store.state.customer.storedData.address },
            hasAddress: null,
        };
    },

    computed: {
        ...mapGetters({
            regions: GET_REGIONS
        }),
    },

    methods: {
        ...mapActions({
           retreiveRegions: RETREIVE_REGIONS, 
        }),
        handleSubmit() {
            this.loading = true;
            axios[this.hasAddress ? 'put' : 'post']('/customer-data/address', this.addressData)
                .then(this.handleSaveSuccess)
                .catch(this.handleError)
                .finally(() => this.loading = false);
        },
        deleteAddress() {
            axios.delete('/customer-data/address')
                .then(() => {
                    this.handleSuccess('customer.address-deleted-success');
                    this.resetForm();
                })
                .catch(this.handleError);
        },
        handleSaveSuccess() {
            if (this.hasAddress) {
                this.handleSuccess('customer.address-updated-success');
            } else {
                this.handleSuccess('customer.address-created-success');
                this.hasAddress = true;
            }
        },
        handleSuccess(message) {
            this.$toast.open(this.trans.get(message));
            this.editing = false;
            if (message.includes('deleted')) {
                this.$store.commit('customerSetStoredData', ['address', null]);
            } else {
                this.$store.commit('customerSetStoredData', ['address', { ...this.addressData }]);
            }
        },
        handleError() {
            this.$toast.error(this.trans.get('customer.something-went-wrong'));
        },
        resetForm() {
            this.hasAddress = false;
            this.addressData = { ...addressData };
        },
    },

    created() {
        this.retreiveRegions();
        this.hasAddress = Object.keys(this.addressData).length !== 0;
    }
}
</script>

<style lang="scss">
.customer-address-book-component {
    .address {
        max-width: 25rem;
    }

    .field-wrapper {
        .field-placeholder span {
            background: white !important;
        }
    }
}
</style>
